/* RWJ native search drawer: intercept the header action before theme navigation handlers. */
(() => {
  const triggerSelector = [
    '[data-rwj-search-trigger]',
    '.search-action [aria-controls="search-modal"]',
    'button[aria-controls="search-modal"]'
  ].join(',');

  const openDrawer = (event) => {
    const trigger = event.target instanceof Element ? event.target.closest(triggerSelector) : null;
    if (!trigger) return;

    const dialog = document.querySelector('#search-modal dialog');
    if (!dialog) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!dialog.open) {
      try { dialog.showModal(); } catch (_) { dialog.setAttribute('open', ''); }
    }
    window.requestAnimationFrame(() => {
      dialog.querySelector('input[type="search"]')?.focus();
    });
  };

  document.addEventListener('pointerdown', openDrawer, true);
  document.addEventListener('click', openDrawer, true);
})();

/* RWJ mobile hero final override — injected after section CSS so mobile preview reflects it. */
(() => {
  const styleId = 'rwj-mobile-hero-final-override-20260818';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media screen and (max-width: 749px) {
      body .rwj-hero {
        position: relative !important;
        overflow: hidden !important;
      }

      body .rwj-hero__media,
      body .rwj-hero__media picture {
        overflow: hidden !important;
      }

      body .rwj-hero__media img {
        width: 100% !important;
        height: 100% !important;
        max-width: none !important;
        object-fit: cover !important;
        object-position: 35% center !important;
        transform: translateX(18px) !important;
        transform-origin: center center !important;
      }

      body .rwj-hero__copy {
        inset: auto 0 0 auto !important;
        left: auto !important;
        right: 0 !important;
        top: auto !important;
        bottom: 0 !important;
        width: min(54%, 232px) !important;
        min-height: 0 !important;
        height: auto !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        justify-content: flex-end !important;
        text-align: left !important;
        padding: 0 15px 28px 12px !important;
        background: linear-gradient(270deg, rgba(0, 0, 0, .50) 0%, rgba(0, 0, 0, .28) 66%, rgba(0, 0, 0, 0) 100%) !important;
      }

      body .rwj-hero__copy .rwj-eyebrow,
      body .rwj-hero__copy .rwj-hero__body,
      body .rwj-hero__copy .rwj-link {
        display: none !important;
      }

      body .rwj-hero__copy h1 {
        max-width: 188px !important;
        margin: 0 !important;
        color: #fff !important;
        text-shadow: 0 1px 16px rgba(0, 0, 0, .36) !important;
      }

      body .rwj-hero__heading-lead,
      body .rwj-hero__heading-rest,
      body .rwj-hero__heading-rest span {
        color: #fff !important;
      }

      body .rwj-hero .rwj-actions {
        margin-top: 16px !important;
        justify-content: flex-start !important;
      }

      body .rwj-hero .rwj-actions .rwj-button {
        min-height: 34px !important;
        padding: 0 12px !important;
        font-size: 8px !important;
        letter-spacing: .08em !important;
        white-space: nowrap !important;
      }
    }
  `;
  document.head.appendChild(style);
})();
